<template>
  <div>
    <!-- 支付弹窗 -->
    <el-dialog
      title="Confirm your payment"
      :visible.sync="dialogVisible"
      width="360px"
      top="calc(15vh + 40px)"
      :center="false"
      custom-class="confirm-dialog"
      :before-close="handleClose"
      :modal="true"
      append-to-body
    >
      <div class="pay-price">${{price / 100}}</div>
      <div class="pay-day">Per {{cycle}}</div>
      <div class="confirm-rule">
        <el-checkbox v-model="agreeRule">I agree to
          <a
            href="https://www.tvunetworks.com/company-terms-and-conditions/"
            target="blank">Terms & Conditions</a>
          and
          <a
            href="https://www.tvunetworks.com/company-privacy-notice/"
            target="blank">Privacy Policy</a>
        </el-checkbox>
        <!-- <div class="agree-btn"></div>
        <div>
          I agree to Terms of Service and Privacy Policy
        </div> -->
      </div>
      <div
        class="pay-button"
        @click="handlePay">
        Proceed to Pay
      </div>
    </el-dialog>
    <!-- 同意试用 -->
    <el-dialog
      title="Confirm your free trial"
      :visible.sync="freeDialog"
      width="360px"
      top="calc(15vh + 40px)"
      :center="false"
      :modal="true"
      custom-class="confirm-dialog"
      :before-close="handleClose"
      append-to-body
    >
      <div class="free-day">15 - DAY FREE TRIAL</div>
      <!-- <div class="free-info">After {{day}} days, your credit card will be charged ${{ price / 100}} per month per Channel.</div> -->
      <div class="free-info">Your free trial will include access to a TVU Channel for {{day}} days without charge, after which you will be charged ${{ price / 100}} USD per month per channel. Any additional channels will cause your card to be charged immediately upon your confirmation.</div>
      <div
        class="pay-button"
        @click="handlePay">
        Confirm
      </div>
    </el-dialog>
    <!-- 试用 过期 -->
    <el-dialog
      title=""
      :visible.sync="trialExpired"
      top="calc(15vh + 40px)"
      width="360px"
      :center="false"
      :modal="true"
      custom-class="confirm-dialog"
      :before-close="handleClose"
      append-to-body
    >
      <img
        src="@/assets/svg/warn.svg"
        alt="">
      <div class="free-day trial-day">TRIAL EXPIRED</div>
      <div class="free-info trial-info">Subscribe for ${{ price }} per {{ cycle }} to lock.</div>
      <div
        class="pay-button"
        @click="handlePay">
        Confirm
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from 'element-ui'
export default {
  props: {
    price: {
      type: [Number, String],
      default: 0
    },
    day: Number,
    cycle: {
      type: String,
      default: ''
    },
    type: String
  },
  data () {
    return {
      dialogVisible: false,
      agreeRule: false,
      freeDialog: false,
      trialExpired: false
    }
  },
  created () {
    if (this.type === 'pay') {
      this.dialogVisible = true
    } else if (this.type === 'free') {
      this.freeDialog = true
    } else if (this.type === 'trial') {
      this.trialExpired = true
    }
  },
  methods: {
    handlePay () {
      if (this.type === 'pay' && !this.agreeRule) {
        return Message.error('please agree')
      }
      this.$emit('handlePay')
    },
    handleClose () {
      this.$emit('handleClose')
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .confirm-dialog {
  // height: 505px;
  border-radius: 20px;
  text-align: center;
  .el-dialog__header::after {
    content: '';
    display: block;
    height: 1px;
    margin-top: 10px;
    background: #dfdfdf;
  }
  .el-dialog__header {
    text-align: left;
    span {
      color: #777;
      font-weight: 500;
    }
  }
  .pay-button {
      margin: 20px auto 0;
      background: #7cc855;
      width: 150px;
      height: 20px;
      line-height: 20px;
      font-size: 18px;
      font-weight: 700;
      padding: 20px 20px;
      border-radius: 30px;
      color: #fff;
      cursor: pointer;
  }
  .pay-price {
    font-size: 45px;
    font-weight: 700;
    color: #292C35;
    margin-top: 50px;
  }
  .pay-day {
    font-size: 14px;
    font-weight: 600;
    color: #777777;
    margin-bottom: 80px;
  }
  .confirm-rule {
    width: 64%;
    margin: 0 auto;
    font-size: 12px;
    color: #777777;
    .el-checkbox {
      display: flex;
      align-items: center;
    }
    .el-checkbox__label {
      white-space: pre-wrap;
      text-align: left;
      color: #606266 !important;
      a {
        text-decoration: none;
      }
    }
  }
  .free-day {
    font-size: 24px;
    font-weight: 600;
    color: #444;
    margin: 40px 0 20px;
  }
  .free-info {
    width: 90%;
    margin: 0 auto;
    font-size: 14px;
    color: #979797;
    font-weight: 400;
    margin-bottom: 30px;
    word-break: break-word;
  }
  .trial-day {
    margin: 40px 0 20px;
  }
  .el-dialog__body {
  /deep/ .el-checkbox {
    .el-checkbox__input.is-checked+.el-checkbox__label {
      color: #606266;
    }
    .el-checkbox__label {

    }
  }
  }

}
</style>
